var Bash = "Bash";
var C = "C";
var Go = "Go";
var Java = "Java";
var JavaScript = "JavaScript";
var Kotlin = "Kotlin";
var Perl = "Perl";
var PHP = "PHP";
var PowerShell = "PowerShell";
var Python = "Python";
var Ruby = "Ruby";
var Rust = "Rust";
var SQL = "SQL";
var Swift = "Swift";
var TypeScript = "TypeScript";
var Analytics = "分析";
var Blockchain = "区块链";
var Compliance = "合规性";
var Compute = "计算";
var Containers = "容器";
var Databases = "数据库";
var Games = "游戏";
var Migration = "迁移";
var Mobile = "移动";
var Networking = "联网";
var Robotics = "机器人";
var Satellite = "卫星";
var Security = "安全性";
var Serverless = "无服务器";
var Storage = "存储";
var WebApps = "Web 应用程序";
var Alexa = "Alexa";
var Apache = "Apache";
var App2Container = "App2Container";
var AppFabric = "AppFabric";
var AppFlow = "AppFlow";
var AppSync = "AppSync";
var Artifact = "Artifact";
var Athena = "Athena";
var Aurora = "Aurora";
var Backup = "备份";
var Batch = "Batch";
var Bedrock = "Bedrock";
var Braket = "Braket";
var Budgets = "预算";
var Chatbot = "Chatbot";
var Chime = "Chime";
var Cloud9 = "Cloud9";
var CloudEndure = "CloudEndure";
var CloudFormation = "CloudFormation";
var CloudFront = "CloudFront";
var CloudHSM = "CloudHSM";
var CloudSearch = "CloudSearch";
var CloudShell = "CloudShell";
var CloudTrail = "CloudTrail";
var CloudWatch = "CloudWatch";
var CodeArtifact = "CodeArtifact";
var CodeBuild = "CodeBuild";
var CodeCatalyst = "CodeCatalyst";
var CodeCommit = "CodeCommit";
var CodeDeploy = "CodeDeploy";
var CodeGuru = "CodeGuru";
var CodePipeline = "CodePipeline";
var CodeStar = "CodeStar";
var Cognito = "Cognito";
var Comprehend = "Comprehend";
var Config = "Config";
var Connect = "Connect";
var Copilot = "Copilot";
var Corretto = "Corretto";
var Dash = "Dash";
var DataSync = "DataSync";
var DataZone = "DataZone";
var DeepComposer = "DeepComposer";
var DeepLens = "DeepLens";
var DeepRacer = "DeepRacer";
var Detective = "检测性";
var DocumentDB = "DocumentDB";
var DynamoDB = "DynamoDB";
var EMR = "EMR";
var EventBridge = "EventBridge";
var Fargate = "Fargate";
var FinSpace = "FinSpace";
var Forecast = "Forecast";
var FreeRTOS = "FreeRTOS";
var FSx = "FSx";
var GameKit = "GameKit";
var GameLift = "GameLift";
var GameSparks = "GameSparks";
var Glue = "Glue";
var GuardDuty = "GuardDuty";
var Health = "健康";
var HealthLake = "HealthLake";
var Inferentia = "Inferentia";
var Inspector = "Inspector";
var Kendra = "Kendra";
var Kinesis = "Kinesis";
var Lambda = "Lambda";
var Lex = "Lex";
var Lightsail = "Lightsail";
var Lookout = "Lookout";
var Lumberyard = "Lumberyard";
var Macie = "Macie";
var Monitron = "Monitron";
var Neptune = "Neptune";
var Neuron = "Neuron";
var One = "One";
var OpenShift = "OpenShift";
var OpsWorks = "OpsWorks";
var Organizations = "Organizations";
var Outposts = "Outposts";
var Panorama = "Panorama";
var Personalize = "Personalize";
var Pinpoint = "Pinpoint";
var Polly = "Polly";
var PrivateLink = "PrivateLink";
var Prometheus = "Prometheus";
var Proton = "Proton";
var QuickSight = "QuickSight";
var Redshift = "Redshift";
var Rekognition = "Rekognition";
var RoboMaker = "RoboMaker";
var SageMaker = "SageMaker";
var Shield = "Shield";
var Snowball = "Snowball";
var Snowcone = "Snowcone";
var Snowmobile = "Snowmobile";
var Sumerian = "Sumerian";
var TensorFlow = "TensorFlow";
var Textract = "Textract";
var Thinkbox = "Thinkbox";
var Timestream = "Timestream";
var Titan = "Titan";
var Transcribe = "Transcribe";
var Translate = "Translate";
var VMware = "VMWare";
var Wavelength = "Wavelength";
var Wickr = "Wickr";
var WorkDocs = "WorkDocs";
var WorkLink = "WorkLink";
var WorkMail = "WorkMail";
var WorkSpaces = "WorkSpaces";
var interests = {
	".NET": ".NET",
	Bash: Bash,
	C: C,
	"C#": "C#",
	"C++": "C++",
	Go: Go,
	Java: Java,
	JavaScript: JavaScript,
	Kotlin: Kotlin,
	Perl: Perl,
	PHP: PHP,
	PowerShell: PowerShell,
	Python: Python,
	Ruby: Ruby,
	Rust: Rust,
	"SAP ABAP": "SAP ABAP",
	SQL: SQL,
	Swift: Swift,
	TypeScript: TypeScript,
	Analytics: Analytics,
	"Application Integration": "应用程序集成",
	"AR/VR": "AR/VR",
	"Architecture Strategy": "架构策略",
	"Artificial Intelligence": "人工智能",
	Blockchain: Blockchain,
	"Business applications": "业务应用程序",
	"Cloud Financial Management": "云财务管理",
	"Cloud Foundations": "云基础知识",
	Compliance: Compliance,
	Compute: Compute,
	"Contact Center": "呼叫中心",
	Containers: Containers,
	"Data Integration": "数据集成",
	Databases: Databases,
	"Developer Tools": "开发人员工具",
	"End-User Computing (EUC)": "终端用户计算（EUC）",
	"Front-End Development": "前端开发",
	Games: Games,
	"Generative AI": "生成式人工智能",
	"High Performance Computing (HPC)": "高性能计算（HPC）",
	"Identity Management": "身份管理",
	"Machine Learning": "机器学习",
	"Machine Learning & AI": "机器学习与人工智能",
	"Management & Governance": "管理与监管",
	"Media services": "媒体服务",
	Migration: Migration,
	Mobile: Mobile,
	Networking: Networking,
	"Networking & Content Delivery": "联网和内容分发",
	"Quantum Technologies": "量子技术",
	Robotics: Robotics,
	Satellite: Satellite,
	Security: Security,
	"Security, Identity, & Compliance": "安全性、身份与合规性",
	Serverless: Serverless,
	Storage: Storage,
	WebApps: WebApps,
	"API Gateway": "API Gateway",
	Alexa: Alexa,
	Apache: Apache,
	"Apache Airflow": "Apache Airflow",
	"Apache Kafka": "Apache Kafka",
	"APP Config": "APP Config",
	"App Mesh": "App Mesh",
	"App Runner": "App Runner",
	"App Studio": "App Studio",
	App2Container: App2Container,
	AppFabric: AppFabric,
	AppFlow: AppFlow,
	"Application Discovery Service": "Application Discovery Service",
	"Application Migration Service": "Application Migration Service",
	"AppStream 2.0": "AppStream 2.0",
	AppSync: AppSync,
	Artifact: Artifact,
	Athena: Athena,
	"Audit Manager": "Audit Manager",
	Aurora: Aurora,
	"Auto Scaling": "Auto Scaling",
	Backup: Backup,
	Batch: Batch,
	Bedrock: Bedrock,
	"Billing Conductor": "账单管理处",
	Braket: Braket,
	Budgets: Budgets,
	"Certificate Manager": "Certificate Manager",
	Chatbot: Chatbot,
	Chime: Chime,
	"Clean Rooms": "Clean Rooms",
	"Cloud Control API": "云管控 API",
	"Cloud Development Kit (CDK)": "云开发工具包（CDK）",
	"Cloud Directory": "Cloud Directory",
	"Cloud Map": "Cloud Map",
	"Cloud WAN": "云 WAN",
	Cloud9: Cloud9,
	CloudEndure: CloudEndure,
	CloudFormation: CloudFormation,
	CloudFront: CloudFront,
	CloudHSM: CloudHSM,
	CloudSearch: CloudSearch,
	CloudShell: CloudShell,
	CloudTrail: CloudTrail,
	CloudWatch: CloudWatch,
	CodeArtifact: CodeArtifact,
	CodeBuild: CodeBuild,
	CodeCatalyst: CodeCatalyst,
	CodeCommit: CodeCommit,
	CodeDeploy: CodeDeploy,
	CodeGuru: CodeGuru,
	CodePipeline: CodePipeline,
	CodeStar: CodeStar,
	Cognito: Cognito,
	Comprehend: Comprehend,
	"Compute Optimizer": "Compute Optimizer",
	Config: Config,
	Connect: Connect,
	"Control Tower": "Control Tower",
	Copilot: Copilot,
	Corretto: Corretto,
	"Cost Explorer": "Cost Explorer",
	Dash: Dash,
	"Data Exchange": "Data Exchange",
	"Data Pipeline": "Data Pipeline",
	"Database Migration Service (DMS)": "Database Migration Service（DMS）",
	DataSync: DataSync,
	DataZone: DataZone,
	"Deadline Cloud": "Deadline Cloud",
	"Deep Learning": "深度学习",
	DeepComposer: DeepComposer,
	DeepLens: DeepLens,
	DeepRacer: DeepRacer,
	Detective: Detective,
	"Device Farm": "Device Farm",
	"DevOps Guru": "DevOps Guru",
	" Direct Connect": " Direct Connect",
	"Directory Service": "Directory Service",
	"Distro for OpenTelemetry": "适用于 OpenTelemetry 的 Distro",
	DocumentDB: DocumentDB,
	DynamoDB: DynamoDB,
	"Elastic Beanstalk": "Elastic Beanstalk",
	"Elastic Block Storage (EBS)": "Elastic Block Storage（EBS）",
	"Elastic Cloud Compute (EC2)": "Elastic Cloud Compute（EC2）",
	"Elastic Container Registry (ECR)": "Elastic Container Registry（ECR）",
	"Elastic Container Service (ECS)": "Elastic Container Service（ECS）",
	"Elastic Disaster Recovery (DRS)": "弹性灾难恢复（DRS）",
	"Elastic File System (EFS)": "Elastic File System（EFS）",
	"Elastic Inference": "Elastic Inference",
	"Elastic Kubernetes Service (EKS)": "Elastic Kubernetes Service（EKS）",
	"Elastic Transcoder": "Elastic Transcoder",
	"Elemental ": "Elemental ",
	EMR: EMR,
	EventBridge: EventBridge,
	Fargate: Fargate,
	"Fault Injection Simulator": "Fault Injection Simulator",
	"File Cache": "File Cache",
	FinSpace: FinSpace,
	"Firewall Manager": "Firewall Manager",
	Forecast: Forecast,
	"Fraud Detector": "Fraud Detector",
	FreeRTOS: FreeRTOS,
	FSx: FSx,
	GameKit: GameKit,
	GameLift: GameLift,
	GameSparks: GameSparks,
	"Global Accelerator": "Global Accelerator",
	Glue: Glue,
	"Ground Station": "地面卫星接收站",
	GuardDuty: GuardDuty,
	Health: Health,
	HealthLake: HealthLake,
	"IAM Identity Center": "IAM Identity Center",
	"Identity and Access Management (IAM)": "Identity and Access Management（IAM）",
	Inferentia: Inferentia,
	Inspector: Inspector,
	"Interactive Video Service": "Interactive Video Service",
	"Internet of Things (IoT)": "物联网（IoT, Internet of Things）",
	Kendra: Kendra,
	"Key Management Service (KMS)": "Key Management Service（KMS）",
	Kinesis: Kinesis,
	"Lake Formation": "Lake Formation",
	Lambda: Lambda,
	"Launch Wizard": "Launch Wizard",
	Lex: Lex,
	"License Manager": "License Manager",
	Lightsail: Lightsail,
	"Local Zones": "Local Zones",
	"Location Service": "Location Service",
	Lookout: Lookout,
	Lumberyard: Lumberyard,
	Macie: Macie,
	"Mainframe Modernization": "大型机现代化",
	"Managed Blockchain": "Managed Blockchain",
	"Managed Grafana": "Managed Grafana",
	Monitron: Monitron,
	"MQ Message Broker": "MQ 消息代理",
	Neptune: Neptune,
	"Network Firewall": "Network Firewall",
	Neuron: Neuron,
	"Nimble Studio": "Nimble Studio",
	One: One,
	"OpenSearch Service (OSS)": "OpenSearch Service（OSS）",
	OpenShift: OpenShift,
	OpsWorks: OpsWorks,
	Organizations: Organizations,
	Outposts: Outposts,
	Panorama: Panorama,
	Personalize: Personalize,
	Pinpoint: Pinpoint,
	Polly: Polly,
	"Private 5G": "Private 5G 服务",
	"Private Certificate Authority": "Private Certificate Authority",
	PrivateLink: PrivateLink,
	Prometheus: Prometheus,
	Proton: Proton,
	"Q ": "Q ",
	"Quantum Solutions Lab": "Quantum Solutions Lab",
	QuickSight: QuickSight,
	"Relational Database Service (RDS)": "Relational Database Service（RDS）",
	Redshift: Redshift,
	Rekognition: Rekognition,
	"rePost Private": "rePost 私人版",
	"Resilience Hub": "韧性监测中心",
	"Resource Access Manager": "Resource Access Manager",
	RoboMaker: RoboMaker,
	"Route 53": "Route 53",
	SageMaker: SageMaker,
	"Secrets Manager": "Secrets Manager",
	"Security Hub": "Security Hub",
	"Security Lake": "Security Lake",
	"Server Migration Service (SMS)": "Server Migration Service（SMS）",
	"Serverless Application Repository": "Serverless Application Repository",
	"Service Catalog": "Service Catalog",
	"Service Management Connector": "服务管理连接器",
	Shield: Shield,
	"Simple Email Service (SES)": "Simple Email Service（SES）",
	"Simple Notification Service (SNS)": "Simple Notification Service（SNS）",
	"Simple Queue Service (SQS)": "Simple Queue Service（SQS）",
	"Simple Storage Service (S3)": "Simple Storage Service（S3）",
	"Simspace Weaver": "Simspace Weaver",
	"Single Sign-On (SSO)": "Single Sign-On（SSO）",
	"Snow Family": "Snow 系列",
	Snowball: Snowball,
	Snowcone: Snowcone,
	Snowmobile: Snowmobile,
	"Step Functions": "Step Functions",
	"Storage Gateway": "Storage Gateway",
	Sumerian: Sumerian,
	"Supply Chain": "供应链",
	"Systems Manager": "Systems Manager",
	"Telco Network Builder": "电信网络构建器",
	TensorFlow: TensorFlow,
	Textract: Textract,
	Thinkbox: Thinkbox,
	Timestream: Timestream,
	Titan: Titan,
	Transcribe: Transcribe,
	Translate: Translate,
	"Trusted Advisor": "Trusted Advisor",
	"Verified Access": "Verified Access",
	"Verified Permissions": "Verified Permissions",
	"Virtual Private Cloud (VPC)": "Virtual Private Cloud（VPC）",
	"Virtual Private Network (VPN)": "虚拟专用网络（VPN）",
	VMware: VMware,
	Wavelength: Wavelength,
	"Web Application Firewall (WAF)": "Web 应用程序防火墙（WAF）",
	Wickr: Wickr,
	WorkDocs: WorkDocs,
	WorkLink: WorkLink,
	WorkMail: WorkMail,
	WorkSpaces: WorkSpaces,
	"X-Ray": "X-Ray"
};

export { Alexa, Analytics, Apache, App2Container, AppFabric, AppFlow, AppSync, Artifact, Athena, Aurora, Backup, Bash, Batch, Bedrock, Blockchain, Braket, Budgets, C, Chatbot, Chime, Cloud9, CloudEndure, CloudFormation, CloudFront, CloudHSM, CloudSearch, CloudShell, CloudTrail, CloudWatch, CodeArtifact, CodeBuild, CodeCatalyst, CodeCommit, CodeDeploy, CodeGuru, CodePipeline, CodeStar, Cognito, Compliance, Comprehend, Compute, Config, Connect, Containers, Copilot, Corretto, Dash, DataSync, DataZone, Databases, DeepComposer, DeepLens, DeepRacer, Detective, DocumentDB, DynamoDB, EMR, EventBridge, FSx, Fargate, FinSpace, Forecast, FreeRTOS, GameKit, GameLift, GameSparks, Games, Glue, Go, GuardDuty, Health, HealthLake, Inferentia, Inspector, Java, JavaScript, Kendra, Kinesis, Kotlin, Lambda, Lex, Lightsail, Lookout, Lumberyard, Macie, Migration, Mobile, Monitron, Neptune, Networking, Neuron, One, OpenShift, OpsWorks, Organizations, Outposts, PHP, Panorama, Perl, Personalize, Pinpoint, Polly, PowerShell, PrivateLink, Prometheus, Proton, Python, QuickSight, Redshift, Rekognition, RoboMaker, Robotics, Ruby, Rust, SQL, SageMaker, Satellite, Security, Serverless, Shield, Snowball, Snowcone, Snowmobile, Storage, Sumerian, Swift, TensorFlow, Textract, Thinkbox, Timestream, Titan, Transcribe, Translate, TypeScript, VMware, Wavelength, WebApps, Wickr, WorkDocs, WorkLink, WorkMail, WorkSpaces, interests as default };
